import { useEffect, useState } from "react";
import { getSubscriptionActivity } from "./subscriptionActivity.api";
import type { SubscriptionActivityData } from "./subscriptionActivity.types";
import "./SubscriptionActivity.css";

function SubscriptionActivity() {
  const [activity, setActivity] =
    useState<SubscriptionActivityData | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadActivity = async () => {
      try {
        const result = await getSubscriptionActivity(controller.signal);
        setActivity(result);
      } catch {
        // Si falla la API, no mostramos cifras inventadas.
      }
    };

    void loadActivity();

    const intervalId = window.setInterval(() => {
      void loadActivity();
    }, 60_000);

    return () => {
      controller.abort();
      window.clearInterval(intervalId);
    };
  }, []);

  if (!activity) return null;

  return (
    <div
      className="subscription-activity"
      aria-label={`${activity.activeCount} ${
        activity.activeCount === 1 ? "profesional" : "profesionales"
      }`}
    >
      <span className="subscription-activity__number">
        {activity.activeCount.toLocaleString("es-ES")}
      </span>
      <span className="subscription-activity__label">
        {activity.activeCount === 1 ? "profesional" : "profesionales"}
      </span>
    </div>
  );
}

export default SubscriptionActivity;
